import { useEffect, useState } from 'react';

// Who you're signed in as, the same corner in Arus Kas and Ops (Director,
// 15 Oct: the Hub is the account home). Avatar + name + role here; the menu
// lists your role in each app and links to the other app, the Hub, and
// (Director) Pengguna & akses in the Hub.
const HUB = 'https://skl.ptmercusuar.com';
const CF = { director: 'Direktur', staff: 'Staf', viewer: 'Viewer' };
const OPS = { director: 'Direktur', staff: 'Staf', fieldops: 'Field Ops' };
const initials = n => String(n || '?').split(/[\s.@]+/).filter(Boolean).slice(0, 2).map(w => w[0].toUpperCase()).join('');

export default function Account({ user, role, logout, lastSync }) {
  const [open, setOpen] = useState(false);
  useEffect(() => { if (!open) return; const c = () => setOpen(false); setTimeout(() => document.addEventListener('click', c, { once: true })); }, [open]);
  const apps = user.apps || { cashflow: role };
  return (
    <div className="v2-acct">
      {/* Same corner in Arus Kas and Ops: data freshness, then who you are. */}
      {lastSync && <div className="v2-sync"><i />Accurate {new Date(lastSync).toLocaleString('id-ID', { day: 'numeric', month: 'short', hour: '2-digit', minute: '2-digit' })}</div>}
      <button type="button" className="v2-acct-btn" onClick={() => setOpen(o => !o)} aria-haspopup="menu" aria-expanded={open}>
        <span className={`ava ${role === 'director' ? 'dir' : ''}`}>{initials(user.name)}</span>
        <span className="v2-acct-who"><b>{user.name}</b><small>{CF[role] || role} · Arus Kas</small></span>
        <span className="v2-acct-chev">{open ? '▾' : '▴'}</span>
      </button>
      {/* Director, 15 Oct: app rows keep their role badge and read "Arus Kas App" /
          "Ops App". The app you're in is marked with ✓ and isn't a link (no
          button that takes you where you already are). */}
      {open && (
        <div className="v2-acct-menu" role="menu" onClick={e => e.stopPropagation()}>
          <div className="hd"><b>{user.name}</b><small>{user.email}</small></div>
          <div className="it here"><span><i>✓</i>Arus Kas App</span><span className={`rolep ${apps.cashflow || role}`}>{CF[apps.cashflow || role]}</span></div>
          {apps.ops && <a className="it" href="https://skl-ops.ptmercusuar.com"><span><i />Ops App</span><span className={`rolep ${apps.ops}`}>{OPS[apps.ops]}</span></a>}
          <div className="sep" />
          {role === 'director' && <a className="it" href={`${HUB}/#akses`}>Pengguna & akses</a>}
          <a className="it" href={HUB}>Semua aplikasi</a>
          <div className="sep" />
          <button type="button" className="it out" onClick={logout}>Keluar</button>
        </div>
      )}
    </div>
  );
}
